import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 32, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, light = false }) => (
  <p className={`text-xs font-semibold uppercase tracking-[0.24em] ${light ? "text-[#E2C372]" : "text-[#9B742A]"}`}>
    <span className="inline-block w-8 h-px align-middle mr-3 bg-current" />
    {children}
  </p>
);
